import React from 'react';

const Knowledge = () => {
  return (
    <svg viewBox="0 0 24 24">
      <circle className="st0" cx="12" cy="12" r="10" />
      <path className="st0" d="M8,14c0,0,1.5,2,4,2s4-2,4-2" />
      <line className="st0" x1="9" y1="9" x2="9" y2="9" />
      <line className="st0" x1="15" y1="9" x2="15" y2="9" />
    </svg>
  );
};

export default Knowledge;